(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    

      var checkNewsletter = function(){
      var date = new Date();
      if(localStorage.getItem('tmx-newsletter') == null || localStorage.getItem('tmx-newsletter') == "undefined" ){
            $("#newsletter-popup").modal({
              fadeDuration: 500
            });
            localStorage.setItem('tmx-newsletter', date );
      }
      else{
        var check_time = new Date(date) - new Date(localStorage.getItem('tmx-newsletter'));
        var ms = check_time % 1000;
        check_time = (check_time - ms) / 1000;
        var days = Math.floor(check_time / 86400);
        if(days > 2){
          $("#newsletter-popup").modal({
              fadeDuration: 500
            });
          localStorage.setItem('tmx-newsletter', date );
        }
      }
    }
    
  $(document).ready(function(){
    if($("#newsletter-popup").length > 0) checkNewsletter();
  });


  } catch(e) { console.error(e); }
})();
})();
